import {
    ChangeDetectionStrategy,
    Component,
    input,
    output,
    OnInit,
    HostBinding,
    ElementRef,
    ViewChild,
    signal,
} from '@angular/core';

import { SelectOption } from '../../models';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FlooriControl } from '../../utils';
import { FlooriIconComponent } from '../floori-icon/floori-icon.component';
import { TranslationsModule } from '../../modules';
@Component({
    selector: 'floori-simple-select',
    standalone: true,
    imports: [FormsModule, FlooriIconComponent, TranslationsModule],
    templateUrl: './floori-simple-select.component.html',
    styleUrl: './floori-simple-select.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: FlooriSimpleSelectComponent,
        },
    ]
})
export class FlooriSimpleSelectComponent extends FlooriControl implements OnInit {
    @ViewChild('triggerInput') triggerInput!: ElementRef<HTMLInputElement>;

    readonly options = input.required<SelectOption[]>();
    readonly defaultValue = input<string>();
    readonly placeholder = input<string>('');
    readonly label = input<string>('');

    readonly selectionChange = output<string>();

    isOpen = signal(false);
    private _value = '';

    get value(): string {
        return this._value;
    }

    set value(val: string) {
        if (val !== this._value) {
            this._value = val;
            this.onChange(this._value);
            this.onTouch(this._value);
            this.selectionChange.emit(this._value);
        }
    }

    @HostBinding('class.floori-simple-select') hostClass = true;

    constructor(private elementRef: ElementRef) {
        super();
    }

    override ngOnInit(): void {
        this.initializeDefaultValue();
    }

    writeValue(value: string): void {
        if (value) {
            this._value = value;
        } else {
            this.initializeDefaultValue();
        }
    }

    toggleDropdown(): void {
        if (!this.disabled) {
            this.isOpen.update(open => !open);
        }
    }

    handleBlur(event: FocusEvent): void {
        if (!this.elementRef.nativeElement.contains(event.relatedTarget)) {
            this.isOpen.set(false);
            this.focusChanged(false);
        }
    }

    selectOption(option: SelectOption): void {
        this.value = option.value?.toString() || '';
        this.isOpen.set(false);
        this.triggerInput.nativeElement.blur();
    }

    getSelectedOptionLabel(): string {
        const selectedOption = this.options()?.find(opt => String(opt.value) === this._value);
        return selectedOption?.label || '';
    }

    private initializeDefaultValue(): void {
        const options = this.options();
        if (!options?.length) return;

        const defaultVal = this.defaultValue();
        if (defaultVal && options.some(opt => String(opt.value) === defaultVal)) {
            this._value = defaultVal;
        } else {
            const firstOptionValue = String(options[0].value);
            this._value = firstOptionValue;
        }
    }
}
